
import FulfillmentOptionsStockInfo from './FulfillmentOptionsStockInfo.vue';
import SubscriptionLearnMoreSlideout from 'JS/subscriptions/shared/components/SubscriptionLearnMoreSlideout.vue';
import SubscriptionOptions from './SubscriptionOptions.vue';
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { format } from 'date-fns';
import { FulfillmentType } from '../../../types/ProductDelivery';
import { Get } from 'vuex-pathify';
import { ILocalStoreJson } from 'src/js/types/LocalStore';
import { IProductDetailProductJson } from '../../../types/PDP';
import { ProductSubscriptionStatus, SubscriptionResource } from 'JS/types/Order';

@Component({
	name: 'FulfillmentOptionsFooterPickup',
	components: {
		SubscriptionOptions,
		SubscriptionLearnMoreSlideout,
		FulfillmentOptionsStockInfo
	}
})
export default class FulfillmentOptions extends Vue {
	@Prop({ type: Boolean, required: false, default: false })
	readonly loading: boolean;

	/* Computed
	============================================*/

	@Get('product')
	readonly product: IProductDetailProductJson;

	@Get('localStore')
	readonly localStore: ILocalStoreJson;

	@Get('currentZip')
	readonly currentZip: string;

	@Get('fetchingProduct')
	readonly fetchingProduct: boolean;

	@Get('hasSelectedVariant')
	readonly hasSelectedVariant: boolean;

	@Get('isInStockForBopus')
	readonly isInStockForBopus: boolean;

	@Get('isInStockInStore')
	readonly isInStockInStore: boolean;

	@Get('inStoreOnly')
	readonly inStoreOnly: boolean;

	@Get('fulfillmentType')
	readonly fulfillmentType: FulfillmentType;

	get showStockInfo() {
		return this.stockSubscriptionFormEnabled || !this.outOfMarket;
	}

	get outOfMarket(): boolean {
		return !this.localStore;
	}

	get stockSubscriptionFormEnabled(): boolean {
		return  !this.isInStockForBopus &&
				!this.isInStockInStore &&
		 		!this.product.notCarriedInStore &&
				!this.outOfMarket &&
				this.product.backInStockInfo.isProductEligible &&
				this.hasSelectedVariant &&
				!this.fetchingProduct;
	}

	get showSubscriptionOptions(): boolean {
		return !this.stockSubscriptionFormEnabled &&
		(this.subscriptionInfo.status === ProductSubscriptionStatus.Eligible 
				|| this.subscriptionInfo.status === ProductSubscriptionStatus.Pending);
	}

	get farmsNextReminderBeforeDue(): string | null {
		if (this.product.subscriptionInfo.status === ProductSubscriptionStatus.Active && !this.product.subscriptionInfo.isDue) {
			return format(new Date(this.product.subscriptionInfo.nextReminder), "eee MM/dd");;
		}
		return null;
	}

	get farmsDeadlineDateWhileDue(): string | null {
		if (this.product.subscriptionInfo.status === ProductSubscriptionStatus.Active && this.product.subscriptionInfo.isDue) {
			return format(new Date(this.product.subscriptionInfo.deadlineDateShort), "eee MM/dd");;
		}
		return null;
	}

	get subscriptionInfo(): SubscriptionResource {
		return this.product.subscriptionInfo;
	}

	setDeliveryType(type: FulfillmentType) {
		this.$store.dispatch('setDeliveryType', 
			{ fulfillmentType: type, allowDisabledOptions: false });
	}

	/* Data
	============================================*/
	showSubscriptionDrawer = false;
	subscriptionFrequencySelection = "";

	/* Methods
	============================================*/
	openSubscriptionDrawer() {
		this.showSubscriptionDrawer = true;
	}

	closeSubscriptionDrawer() {
		this.showSubscriptionDrawer = false;
	}

	updateFrequencySelection(newVal: string) {
		this.subscriptionFrequencySelection = newVal;
		if (this.subscriptionInfo.status === ProductSubscriptionStatus.Eligible || this.subscriptionInfo.status === ProductSubscriptionStatus.Pending ) {
			this.$store.commit("subscriptionFrequency",  newVal !== "" ? parseInt(newVal) : null);
		}
	}

	@Watch('subscriptionInfo')
	onSubscriptionInfoChange(currentSubscriptionInfo: SubscriptionResource) {
		if (currentSubscriptionInfo.status !== ProductSubscriptionStatus.Eligible && currentSubscriptionInfo.status !== ProductSubscriptionStatus.Pending) {
			this.$store.commit("subscriptionFrequency", null);
		}
	}
}
